import React from 'react';
import moment from 'moment';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow
} from '@material-ui/core';
import withStyles from '@material-ui/core/styles/withStyles';

const styles = {
  row: {
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f5f5f5 !important'
    }
  }
};

const formatCreatedDate = date => {
  const value = moment(date);
  return value.isValid() ? value.format('MM/DD/YYYY') : 'None';
};

const formatAssociateSplit = ruleJson => {
  let rule = ruleJson;
  if (typeof rule === 'string') {
    try {
      rule = JSON.parse(rule);
    } catch (e) {
      return 'None';
    }
  }

  const split = rule && Number(rule.gci_split);
  if (!Number.isFinite(split)) return 'None';
  const associateSplit = Math.round(split * 10000) / 100;
  const houseSplit = Math.round((100 - associateSplit) * 100) / 100;
  return `${associateSplit}% / ${houseSplit}%`;
};

const GCIExceptionEntriesTable = ({ classes, entries, onEditException }) => (
  <Table>
    <TableHead>
      <TableRow>
        <TableCell style={{ width: 80 }}>#</TableCell>
        <TableCell>Title</TableCell>
        <TableCell>Associate / House Split</TableCell>
        <TableCell>Created Date</TableCell>
        <TableCell>Submitted By</TableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      {entries.map((entry, index) => (
        <TableRow
          hover
          className={classes.row}
          key={entry.id}
          onClick={() => onEditException(entry)}
        >
          <TableCell>{index + 1}</TableCell>
          <TableCell>{entry.title || 'Untitled'}</TableCell>
          <TableCell>{formatAssociateSplit(entry.rule_json)}</TableCell>
          <TableCell>{formatCreatedDate(entry.date_created)}</TableCell>
          <TableCell>{entry.submitter_name || 'None'}</TableCell>
        </TableRow>
      ))}
      {entries.length === 0 && (
        <TableRow>
          <TableCell colSpan={5}>None</TableCell>
        </TableRow>
      )}
    </TableBody>
  </Table>
);

GCIExceptionEntriesTable.defaultProps = {
  onEditException: () => {}
};

export default withStyles(styles)(GCIExceptionEntriesTable);
